
import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

export interface CommunicationPreferencesProps {
  emailMarketing: boolean;
  emailProjectUpdates: boolean;
  emailCommunityUpdates: boolean;
  onPreferenceChange: (key: string, checked: boolean) => void;
  disabled?: boolean;
}

export function CommunicationPreferences({
  emailMarketing,
  emailProjectUpdates,
  emailCommunityUpdates,
  onPreferenceChange,
  disabled = false
}: CommunicationPreferencesProps) {
  return (
    <div className="space-y-4">
      <div className="flex items-start space-x-3">
        <Checkbox 
          id="emailMarketing" 
          checked={emailMarketing} 
          onCheckedChange={(checked) => onPreferenceChange('email_marketing', checked as boolean)}
          disabled={disabled}
        />
        <div className="grid gap-1.5">
          <Label 
            htmlFor="emailMarketing" 
            className="text-sm font-medium leading-none cursor-pointer"
          >
            Marketing emails
          </Label>
          <p className="text-sm text-muted-foreground">
            Receive emails about new features, promotions, and knitting tips
          </p>
        </div>
      </div>

      <div className="flex items-start space-x-3">
        <Checkbox 
          id="emailProjectUpdates" 
          checked={emailProjectUpdates} 
          onCheckedChange={(checked) => onPreferenceChange('email_project_updates', checked as boolean)}
          disabled={disabled}
        />
        <div className="grid gap-1.5">
          <Label 
            htmlFor="emailProjectUpdates" 
            className="text-sm font-medium leading-none cursor-pointer"
          >
            Project updates
          </Label>
          <p className="text-sm text-muted-foreground">
            Receive updates about new patterns and projects
          </p>
        </div>
      </div>

      <div className="flex items-start space-x-3">
        <Checkbox 
          id="emailCommunityUpdates" 
          checked={emailCommunityUpdates} 
          onCheckedChange={(checked) => onPreferenceChange('email_community_updates', checked as boolean)}
          disabled={disabled}
        />
        <div className="grid gap-1.5">
          <Label 
            htmlFor="emailCommunityUpdates" 
            className="text-sm font-medium leading-none cursor-pointer"
          >
            Community updates
          </Label>
          <p className="text-sm text-muted-foreground">
            Receive updates about community events
          </p>
        </div>
      </div>
    </div>
  );
}
